// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"500c69d4","64":"f70a0692","406":"8ac94507","495":"b04462dc","521":"2caf9100","577":"f1d15b52","631":"32eda3f4"}[chunkId] + ".chunk.js";
};